import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';

@inject('store')
@observer
class TextInput extends React.Component {
  render () {
    const { field, hideAsterik, placeholder, isTextbox } = this.props;
    let autoFocus = false;
    let disabled = false;
    let readonly = false;

    if (this.props.autoFocus) {
      autoFocus = this.props.autoFocus;
    }
    if (this.props.disabled) {
      disabled = this.props.disabled;
    }
    if (this.props.readonly) {
      readonly = this.props.readonly;
    }

    let cont = `form-group col-sm-${this.props.cols} ${field.errors.length > 0 && 'has-error'}`;
    if (this.props.removeMB) {
      cont = `col-sm-${this.props.cols} ${field.errors.length > 0 && 'has-error'}`;
    }

    const inputProps = {
      name: field.name,
      placeholder: placeholder || field.label,
      className: `form-control ${field.errors.length > 0 && 'error-input'}`,
      value: field.value,
      onChange: this.props.handleChange,
      disabled: disabled,
      readOnly: readonly,
      'aria-label': field.label,
      'aria-required': field.required,
      autoFocus: autoFocus,
      autoComplete: 'off',
    };
    return (
      <div className={classNames(cont, { 'five-px-padding-right': this.props.no_r_padding, 'five-px-padding-left': this.props.no_l_padding })}>
        {!this.props.hideLabel && (
          <label className="chalice-label">{field.label}<sup className="text-danger">{field.required && !hideAsterik && '*'}</sup></label>
        )}
        <div onClick={this.props.handleCopyLink} className={this.props.className}>
          {isTextbox ? (
            <textarea
              {...inputProps}
              rows="4"
            />
          ) : (
            <input
              type="text"
              {...inputProps}
            />
          )}
          <span className="input-group-postpend">
            <i className={`input-icon ${this.props.icon}`}></i>
          </span>
          {field.errors.length > 0 && field.errors.map(error => (
            <div key={error} className="text-danger">
              {error}&nbsp;
            </div>
          ))}
        </div>
      </div>
    );
  }
}

TextInput.propTypes = {
  autoFocus: PropTypes.bool,
  field: PropTypes.object,
  className: PropTypes.string,
  hideLabel: PropTypes.any,
  no_r_padding: PropTypes.bool,
  no_l_padding: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  removeMB: PropTypes.bool,
  icon: PropTypes.string,
  cols: PropTypes.number,
  isChecked: PropTypes.bool,
  handleChange: PropTypes.func,
  handleCopyLink: PropTypes.func,
  hideAsterik: PropTypes.bool,
  placeholder: PropTypes.string,
  isTextbox: PropTypes.bool, // Add this prop to determine if it's a textarea
};

export default TextInput;
